import { render, staticRenderFns } from "./DepositTabTable.vue?vue&type=template&id=635b753e"
import script from "./DepositTabTable.vue?vue&type=script&lang=js"
export * from "./DepositTabTable.vue?vue&type=script&lang=js"
import style0 from "./DepositTabTable.vue?vue&type=style&index=0&id=635b753e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports